import { PlanType } from "./plan-type";

export const PlanId = {
    Business: process.env.REACT_APP_PLAN_BUSINESS_ID!,
    Core: process.env.REACT_APP_PLAN_CORE_ID!,
    Pro: process.env.REACT_APP_PLAN_PRO_ID!,
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PlanId = typeof PlanId[keyof typeof PlanId];

export const PlanIdPlanType: Record<PlanId, PlanType> = {
    [PlanId.Business]: PlanType.Business,
    [PlanId.Core]: PlanType.Core,
    [PlanId.Pro]: PlanType.Pro,
};